import React, { FC } from 'react';
import './styles.scss';

export const Header: FC = () => {
  return (
    <header className="inbox-header">
      <div className="inbox-header__title">
        <h4>Chats</h4>
      </div>
    </header>
  );
};
